import React from "react";
import { toast } from "sonner";
import { Share2, MessageCircle, Mail, Link as LinkIcon } from "lucide-react";

export default function ShareButtons({ title, url, testidPrefix = "share" }) {
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch {}
    } else {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    }
  };
  const wa = `https://wa.me/?text=${encodeURIComponent(`${title} — ${url}`)}`;
  const em = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied");
  };
  return (
    <div className="flex items-center gap-2">
      <button
        data-testid={`${testidPrefix}-native`}
        onClick={share}
        className="w-10 h-10 rounded-full grid place-items-center press"
        style={{ border: "1px solid rgba(27,25,23,0.15)", color: "var(--ink)" }}
        aria-label="Share"
      ><Share2 size={15} strokeWidth={1.6} /></button>
      <a
        data-testid={`${testidPrefix}-whatsapp`}
        href={wa}
        target="_blank" rel="noopener noreferrer"
        className="w-10 h-10 rounded-full grid place-items-center press"
        style={{ background: "#25D366", color: "#fff" }}
        aria-label="Share via WhatsApp"
      ><MessageCircle size={15} strokeWidth={1.8} /></a>
      <a
        data-testid={`${testidPrefix}-email`}
        href={em}
        className="w-10 h-10 rounded-full grid place-items-center press"
        style={{ border: "1px solid rgba(27,25,23,0.15)", color: "var(--ink)" }}
        aria-label="Share via Email"
      ><Mail size={15} strokeWidth={1.6} /></a>
      <button
        data-testid={`${testidPrefix}-copy`}
        onClick={copy}
        className="w-10 h-10 rounded-full grid place-items-center press"
        style={{ border: "1px solid rgba(27,25,23,0.15)", color: "var(--ink)" }}
        aria-label="Copy link"
      ><LinkIcon size={15} strokeWidth={1.6} /></button>
    </div>
  );
}
